((Sliders, $) => {
  'use strict';

  const $dom = {};
  const prevArrow = '<div class="slick-arrow prev"><div class="slider--arrow"></div></div>';
  const nextArrow = '<div class="slick-arrow next"><div class="slider--arrow"></div></div>';

  let previousWidth = null;
  let windowWidth = $(window).width();

  const cacheDom = () => {
    $dom.productThumbnailSlider = $('.js-product-thumbnails-slider');
    $dom.productThumbnailSliderArrows = $('.js-product-thumbnails-slider-arrows');

    $dom.productFeaturedSlider = $('.js-product-featured-slider');
  };

  const setSliderLoadEvents = () => {
    productThumbnailSliderLoadEvents();
    productFeaturedSliderLoadEvents();
  };

  const thumbnailOnLoad = window.Helpers.debounce(() => {
    resizeSlideImages($dom.productThumbnailSlider);
    $(window).trigger('resize');
    const $currSlide = $('.product--images-thumbnails-link.active').closest('.slick-slide');
    const currSlide = $currSlide.data('slick-index');
    $dom.productThumbnailSlider.slick('slickGoTo', $currSlide.index(), true);
    $dom.productThumbnailSlider.removeClass('is-loading');
  }, 300);

  const productThumbnailSliderLoadEvents = () => {
    if (!$dom.productThumbnailSlider.length) {
      return true;
    }

    $dom.productThumbnailSlider.on('init lazyLoaded', function (e) {
      thumbnailOnLoad();
    });

    $dom.productThumbnailSlider.on('setPosition', function (e) {
      setTimeout(function () {
        resizeSlideImages($dom.productThumbnailSlider);
      }, 0);
    });
  };

  const featuredOnLoad = window.Helpers.debounce(() => {
    const slideImage = $dom.productFeaturedSlider.find('img');
    if (slideImage.complete && slideImage.naturalHeight) {
      resizeSlideImages($dom.productFeaturedSlider);
      $(window).trigger('resize');
      $dom.productFeaturedSlider.removeClass('is-loading');
    } else {
      slideImage.on('load', () => {
        resizeSlideImages($dom.productFeaturedSlider);
        $(window).trigger('resize');
        $dom.productFeaturedSlider.removeClass('is-loading');
      });
      slideImage.on('error', (error) => console.log(error));
    }
  }, 300);

  const productFeaturedSliderLoadEvents = () => {
    if (!$dom.productFeaturedSlider.length) {
      return true;
    }

    $dom.productFeaturedSlider.on('init lazyLoaded', function (e) {
      featuredOnLoad();
    });

    $dom.productFeaturedSlider.on('setPosition', function () {
      setTimeout(function () {
        resizeSlideImages($dom.productFeaturedSlider);
      }, 0);
    });
  };

  const quickviewFeaturedSliderLoadEvents = () => {
    const $quickviewFeaturedSlider = $('.js-quickview-product-featured-slider');
    if (!$quickviewFeaturedSlider.length) {
      return true;
    }

    $quickviewFeaturedSlider.on('init', function () {
      const onLoad = () => {
        resizeSlideImages($quickviewFeaturedSlider);
        $(window).trigger('resize');
      };
      setTimeout(function () {
        const slideImage = $quickviewFeaturedSlider.find('img');
        if (slideImage.complete && slideImage.naturalHeight) {
          onLoad();
        } else {
          slideImage.on('load', onLoad);
          slideImage.on('error', (error) => console.log(error));
        }
      }, 0);
    });

    $quickviewFeaturedSlider.on('setPosition', function () {
      setTimeout(function () {
        resizeSlideImages($quickviewFeaturedSlider);
      }, 0);
    });
  };

  const initWindowWidth = () => {
    previousWidth = windowWidth;
    windowWidth = $(window).width();
  };

  const initProductThumbnailSlider = () => {
    if (!$dom.productThumbnailSlider.length || $dom.productThumbnailSlider.hasClass('slick-initialized')) {
      return;
    }
    const mobileSettings = {
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToScroll: 1,
      infinite: false,
      slidesToShow: 4,
      appendArrows: $dom.productThumbnailSliderArrows,
      lazyLoad: 'ondemand',
    };
    const desktopSettings = {
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToScroll: 1,
      infinite: false,
      // default to default options (slick breakpoints are high-to-low)
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 5,
      appendArrows: $dom.productThumbnailSliderArrows,
      lazyLoad: 'ondemand',
    };

    const onLoad = () => {
      const options = windowWidth <= 800 ? mobileSettings : desktopSettings;

      $dom.productThumbnailSlider.slick(options);
    };

    onLoad();
  };

  const destroyProductThumbnailSlider = () => {
    if (
      $dom.productThumbnailSlider.hasClass('slick-initialized') &&
      ((windowWidth > 800 && previousWidth <= 800) || (windowWidth <= 800 && previousWidth > 800))
    ) {
      $dom.productThumbnailSlider.slick('slickUnfilter');
      $dom.productThumbnailSlider.slick('unslick');
    }
  };

  const initProductFeaturedSlider = () => {
    if (!$dom.productFeaturedSlider.length) {
      return true;
    }

    const options = {
      dots: false,
      mobileFirst: true,
      slidesToScroll: 1,
      slidesToShow: 1,
      infinite: false,
      waitForAnimate: false,
      asNavFor: '.js-product-thumbnails-slider',
      lazyLoad: 'ondemand',
      responsive: [
        {
          breakpoint: 800,
          settings: {
            dots: false,
          },
        },
      ],
    };

    if (windowWidth > 800) {
      if ($dom.productFeaturedSlider.hasClass('slick-initialized')) {
        $dom.productFeaturedSlider.slick('unslick');
      }
    } else {
      if (!$dom.productFeaturedSlider.hasClass('slick-initialized')) {
        $dom.productFeaturedSlider.slick(options);
      }
    }
  };


  const initQuickviewFeaturedSlider = () => {
    quickviewFeaturedSliderLoadEvents();

    const $quickviewFeaturedSlider = $('.js-quickview-product-featured-slider');
    if (!$quickviewFeaturedSlider.length) {
      return true;
    }

    const options = {
      slidesToScroll: 1,
      slidesToShow: 1,
      infinite: false,
      waitForAnimate: false,
      prevArrow: '<div class="slick-arrow prev"><div class="slider--arrow fas fa-arrow-left"></div></div>',
      nextArrow: '<div class="slick-arrow next"><div class="slider--arrow fas fa-arrow-right"></div></div>',
    };

    $quickviewFeaturedSlider.slick(options);
  };

  const initSwatchSlider = () => {
    const $swatchSlider = $('.js-swatch-slider');
    if (!$swatchSlider.length) {
      return true;
    }

    $swatchSlider.each((index, slider) => {
      const $slider = $(slider);
      const swatchCount = $slider.find(`.swatch-wrapper`).length;
      const $prevArrow = $slider.closest(`.product-grid-item__colors-wrapper`).find(`.swatches__slider-arrow--prev`);
      const $nextArrow = $slider.closest(`.product-grid-item__colors-wrapper`).find(`.swatches__slider-arrow--next`);
      const maxSwatches = $slider.closest(`.search-results`).length > 0 ? 10 : 12;

      const options = {
        slidesToScroll: 1,
        infinite: false,
        waitForAnimate: false,
        draggable: false,
        swipe: false,
        swipeToSlide: false,
        variableWidth: false,
        slidesToShow: swatchCount > maxSwatches ? maxSwatches - 2 : maxSwatches,
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: swatchCount > 8 ? 8 : 10,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: swatchCount > 8 ? 6 : 8,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              variableWidth: true,
              slidesToShow: 10,
              swipe: true,
              swipeToSlide: true,
              touchThreshold: 100,
            },
          },
          {
            breakpoint: 800,
            settings: {
              variableWidth: true,
              slidesToShow: 8,
              swipe: true,
              swipeToSlide: true,
              touchThreshold: 100,
            },
          },
          {
            breakpoint: 767,
            settings: {
              variableWidth: true,
              slidesToShow: 6,
              swipe: true,
              swipeToSlide: true,
              touchThreshold: 100,
            },
          },
        ],
      };

      $slider.slick(options);
    });
  };

  const resizeSlideImages = (slider) => {
    if (slider.length > 0 && slider.hasClass('slick-initialized') && slider.find('img').length > 0) {
      const slideWidth = slider.find('.slick-slide').first().outerWidth();
      const imgWidth = slider.find('img').get(0).naturalWidth;
      const imgHeight = slider.find('img').get(0).naturalHeight;
      let newHeight = (slideWidth / imgWidth) * imgHeight;
      if (slideWidth > imgWidth) {
        newHeight = imgHeight;
      }
      slider.find('img').each(function () {
        $(this).css({ height: `${newHeight - 2}px` });
      });
    }
  };

  const initSliders = () => {
    initProductThumbnailSlider();
    initProductFeaturedSlider();
    initSwatchSlider();
  };

  const resizeSliders = () => {
    destroyProductThumbnailSlider();
    initProductFeaturedSlider();
  };

  const bindUIActions = () => {
    $(window).on('resize', () => {
      initWindowWidth();
      resizeSliders();
    });

    // fires on resize to/from 800+ px
    $dom.productThumbnailSlider.on('destroy', function () {
      setTimeout(initProductThumbnailSlider, 0);
    });

    $(document).on('click', `.js-product-thumbnails-slider .slick-slide`, function () {
      if (windowWidth <= 800) {
        const firstSlideIndex = $dom.productThumbnailSlider.find(`.slick-slide`).eq(0).data(`slick-index`);
        const currentSlideIndex = $(this).data('slick-index');
        const slideNum = currentSlideIndex - firstSlideIndex;
        $dom.productFeaturedSlider.slick('slickGoTo', slideNum);
      }
    });

    $dom.productFeaturedSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      const $activeThumbnail = $dom.productThumbnailSlider.find('.product--images-thumbnails-link.active');
      if ($activeThumbnail.closest('.slick-slide').data('slick-index') !== nextSlide) {
        $activeThumbnail.removeClass('active');
        $dom.productThumbnailSlider
          .find(`.slick-slide`)
          .eq(nextSlide)
          .find('.product--images-thumbnails-link')
          .addClass('active');
      }
    });
  };

  const init = () => {
    cacheDom();
    setSliderLoadEvents();
    initSliders();
    bindUIActions();
  };


  Sliders.init = init;
  Sliders.initQuickviewFeaturedSlider = initQuickviewFeaturedSlider;
})((window.Sliders = window.Sliders || {}), jQuery);
